import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { sentinel: String }
  static classes = ["stuck"]

  connect() {
    const sentinel = document.getElementById(this.sentinelValue)
    if (!sentinel) return

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.element.classList.toggle(this.stuckClass, !entry.isIntersecting)
      },
      { threshold: 0 }
    )
    this.observer.observe(sentinel)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
